import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const circleSo = defineConnector({
  identifier: "circleSo",
  name: "Circle.so",
  tagLine: "Online community platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://app\\.circle\\.so/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: app.secret.apiKey,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Find your Circle.so API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to [Circle.so](https://app.circle.so/) and go to **Settings → Developers → API** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Circle.so account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText: "The API key for your Circle.so account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.circle.so/api/v1/me",
  },
});
